/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ds, { media } from 'designsystem';
import { Column } from 'hedron';
import styled from 'styled-components';

const labelWidth = '68%';

const fontScale = 0.85; // scale fonts for mobile details view - without this param, values wont fit

const Container = styled(Column)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: ${ds.get('metrics.xs')};
  padding-left: ${ds.get('metrics.s')};

  ${({ alignRight }) => (alignRight ? 'align-items: flex-end;' : '')}
  ${({ smallPadding }) => (smallPadding ? `padding: ${ds.get('metrics.xs')};` : '')}

  ${media.mobile`
    padding: ${ds.get('metrics.s')};
    padding-top: 0;
    padding-bottom: ${ds.get('metrics.xs')};
  `}
`;

const Label = styled.p`
  position: relative;
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('xs')};
  line-height: ${ds.get('type.lineHeight.xs')};
  color: ${({ white }) => (white ? ds.brand('background') : ds.brand('product'))};

  z-index: 1;
  font-weight: ${({ labelBold }) => (labelBold
    ? ds.get('type.fontWeight.regular')
    : ds.get('type.fontWeight.light')
  )};
  
  ${({ center }) => (center ? `
    text-align: center;
  ` : '')}
  
  ${({ alignRight }) => (alignRight ? 'text-align: end;' : '')}

  width: 100%;

  ${media.mobile`
    font-size: ${ds.fs('s')};
  `}

  ${media.tablet`
    width: ${({ labelWide }) => (labelWide ? '100%' : labelWidth)};
  `}

  ${media.desktop`
    font-weight: ${({ labelBold }) => (labelBold
    ? ds.get('type.fontWeight.bold')
    : ds.get('type.fontWeight.light'))};
    
    ${({ center }) => (center ? `
      top: -12%;
    ` : '')}
`}
`;

const Value = styled.p`
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: calc(${ds.fs('m')} * ${fontScale});
  z-index: 1;
  margin: 0;
  color: ${({ white }) => (white ? ds.brand('background') : ds.brand('product'))};
  font-weight: ${({ valueBold }) => (valueBold
    ? ds.get('type.fontWeight.bold')
    : ds.get('type.fontWeight.regular'))};

  ${({ center }) => (center ? 'text-align: center' : '')}

  ${media.tablet`
    font-size: calc(${ds.fs('l')} * ${fontScale});
    ${({ center }) => (center ? `
      width: ${labelWidth};
    ` : '')};
  `};
`;

const Unit = styled.span`
  color: ${({ white }) => (white ? ds.brand('background') : ds.brand('product'))};
  font-weight: ${ds.get('type.fontWeight.regular')};
  font-size: ${({ bigUnit }) => (bigUnit ? `calc(${ds.fs('m')} * ${fontScale})` : `calc(${ds.fs('base')} * ${fontScale})`)};
  
  ${media.tablet`
    font-size: ${({ bigUnit }) => (bigUnit ? `calc(${ds.fs('l')} * ${fontScale})` : ds.fs('m'))};
  `}
  
`;

const Sign = styled.span`
  position: absolute;
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('s')};
  color: ${ds.brand('white')};

  z-index: 1;
  right: -10%;

  bottom: calc(${ds.get('metrics.xs')} + 3px);
  font-weight: ${ds.get('type.fontWeight.light')};

  ${({ bigSign }) => (bigSign ? `
    bottom: ${ds.get('metrics.xs')};
    font-size: ${ds.fs('m')};
    transform: translate(-${ds.get('metrics.m')}, 0);
  ` : '')}

  ${media.mobile`
    right: 0%;
    bottom: ${ds.get('metrics.xs')};
  `}

  ${media.tablet`
    right: 7%;
    font-size: ${ds.fs('m')};
    bottom: calc(${ds.get('metrics.s')} * 0.8);
    font-weight: ${ds.get('type.fontWeight.bold')};

    ${({ bigSign }) => (bigSign ? `
      font-size: ${ds.fs('l')};
      transform: translate(0, 20%);
    ` : '')}

    ${({ signLeft }) => (signLeft ? `
      right: 115%;
    ` : '')}

    ${({ signBottom }) => (signBottom ? `
      right: 85%;
      bottom: -${ds.get('metrics.base')};
    ` : '')}
  `}
`;

const Icon = styled.img`
  position: absolute;
  top: ${ds.get('metrics.s')};
  left: ${ds.get('metrics.s')};
  width: ${ds.get('metrics.xl')};

  ${media.desktop`
    opacity: 0.2;
  `}
`;

const WhiteBackground = styled.div`
  position: absolute;
  width: 75%;
  height: 120%;
  left: 0;
  top: -10%;
  background-color: ${ds.brand('background')};
`;

const power = unit => (unit === 'm2' ? (
  <span>
    {'m'}
    <sup>
      {'2'}
    </sup>
  </span>) : unit);

@inject('windowStore')
@observer
export default class CalculatorDetailsItem extends Component {
  render() {
    const {
      windowStore,
      icon,
      label,
      labelBold,
      labelWide,
      alignRight,
      value,
      valueBold,
      unit,
      bigUnit,
      sign,
      signLeft,
      signBottom,
      bigSign,
      calculatorValue,
      white,
      center,
      mobileWidth2x,
      smallPadding,
    } = this.props;

    return (
      <Container
        xs={mobileWidth2x ? 6 : 3}
        lg={2}
        alignRight={alignRight}
        smallPadding={smallPadding}
      >
        {white && <WhiteBackground />}
        {windowStore.isOnDesktop && icon && (
          <Icon
            src={icon}
            alt={label || calculatorValue.label}
          />
        )}
        <Label
          white={!white}
          labelBold={labelBold}
          center={center}
          labelWide={labelWide}
          alignRight={alignRight}
        >
          {label || calculatorValue.label}
        </Label>
        <Value
          valueBold={valueBold}
          white={!white}
          center={center}
        >
          {value !== null
            ? value.toLocaleString() || value
            : calculatorValue.value.toLocaleString() || calculatorValue.value}
          <Unit
            bigUnit={bigUnit}
            white={!white}
          >
            {' '}
            {power(unit || calculatorValue.unit)}
          </Unit>
        </Value>
        {sign && (
          <Sign
            signBottom={signBottom}
            signLeft={signLeft}
            bigSign={bigSign}
          >
            {sign}
          </Sign>
        )}
      </Container>
    );
  }
}
CalculatorDetailsItem.defaultProps = {
  calculatorValue: {
    label: '',
    value: '',
    unit: '',
  },
  icon: '',
  label: '',
  labelBold: false,
  labelWide: false,
  value: null,
  valueBold: false,
  unit: '',
  bigUnit: false,
  sign: '',
  bigSign: false,
  signLeft: false,
  signBottom: false,
  alignRight: false,
  white: false,
  center: false,
  smallPadding: false,
  mobileWidth2x: false,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorDetailsItem/index.jsx